export default {
  base: {
    continue: 'Далі',
    back: 'Назад',
    confirm: 'Підтвердити',
    important: 'Увага!',
    cancel: 'Відмінити',
    add: 'Додати',
    yes: 'Так',
    empty_list: 'Список пустий',
    save: 'Зберегти',
    back_to_main: 'Повернутись на головну',
  },
  auth: {
    registerForm: {
      email: 'E-mail',
      email_hint: 'Приклад: yourmail@gmai.com',
      full_name: 'Ваше ім\'я та прізвище',
      full_name_hint: 'Приклад: Андрій Сидорчук',
      phone: 'Номер телефону',
      title: 'Підключіться сьогодні! Повний функціонал без оплат до 30 днів',
      already_exist: 'В мене вже є акаунт',
      why_email: 'На email будуть відправлені дані для входу',
      why_phone: 'На телефон відправимо SMS з кодом',
    },
    loginForm: {
      title: 'Вхід в акаунт keyCRM',
      domain_name: 'Домен компанії',
      domain_hint: 'Наприклад: minitoys, megatrading, mebli-torg',
      last_visited_tenants: 'Раніше відвідані CRM:',
      password: 'Пароль',
      login: 'Вхід',
      forgotPassword: 'Забули пароль?',
      rememberMe: 'Запам\'ятати мене',
      noAccount: 'Немає акаунту?',
      register: 'Зареєструватись',
      login_failed: 'Некоректний E-mail або пароль',
      password_refreshed: 'Пароль успішно оновлено',
    },
    forgotPassword: {
      title: 'Відновлення паролю',
      subTitle: 'Введіть вашу E-mail адресу для відновлення паролю',
      toLogin: 'Назад',
      reset: 'Скинути',
      resetFailed: 'Користувач з таким E-mail не існує',
      toManyRequests: 'Забагато невдалих спроб. Будь ласка, спробуйте пізніше',
      sent: 'Посилання для скидання пароля надіслано на вашу електронну пошту',
      expired: 'Посилання для скидання пароля більше недоступне'
    },
    resetPassword: {
      title: 'Скидання паролю',
      password: 'Новий пароль',
      passwordConfirmation: 'Підтвердження нового паролю',
      save: 'Зберегти',
      passwordConfirmationFailed: 'Паролі не співпадають',
      success: 'Пароль успішно оновлено! Будь ласка, виконайте вхід'
    }
  },
  app: {
    newInstance: {
      title: 'Створюємо акаунт',
      awaiting: 'Будь ласка, дочекайтесь завершення встановлення CRM!',
      await_install: 'CRM успішно додано. Будь ласка, дочекайтесь встановлення!',
      account_name_hint: 'Якою буде адреса для входу в keyCRM<br /> для вашої компанії?',
      account_name_example: 'Наприклад: minitoys, megatrading, mebli-torg',
      account_name_requirements: 'Тільки латинські букви (від 4 до 20), цифри та дефіс',
      account_name_taken: 'Цей домен вже зайнятий',
      confirmation: '<ul style="padding-left: 20px"><li>Ви обрали <strong>{{domain}}</strong> як назву домену.</li> <li>Обрану назву неможливо буде змінити в майбутньому.</li><li>Ви та ваші співробітники будуть входити в keyCRM по посиланню:</li></ul><strong>https://{{domain}}.keycrm.app</strong><br /><br />Ви впевнені, що хочете використовувати саме таку назву?',
      register_thank: 'Дякуємо, що зареєструвались!',
      account_created: 'Дані для входу в keyCRM відправлені на ваш Email',
      account_ready: 'CRM {{instance}} готова до використання',
      account_creation_in_progress: 'Роботи забігали та працюють, створюючи для вас особистий кабінет keyCRM',
      account_enter_now: 'Увійти в акаунт зараз',
      account_tariff: 'Я ознайомлений(а) з <a href="https://keycrm.app/pricing" target="_blank">тарифами</a>',
      account_tos: 'Реєструючись, ви погоджуєтесь з <a href="https://keycrm.app/terms-of-use" target="_blank">Умовами використання</a> та <a href="https://keycrm.app/privacy-policy" target="_blank">Політикою конфіденційності</a>',
      text_spam: 'Якщо E-mail не прийшов протягом 5 хвилин - <strong>обов\'язково</strong> перевірте папку СПАМ',
      text_spam_gmail: '(а також вкладки Реклама, Промоакції та інші в Gmail)',
      or: 'Або',
      go_to_profile: 'Перейти до профілю',
      go_to_crm: 'Перейти в CRM',
      first_steps: 'Покрокове налаштування keyCRM',
      faq: 'Часто задавані питання',
      q1: 'Чи потрібно прив’язувати картку до акаунту? Чи є автосписання?',
      a1: 'Ні, не потрібно. Ми взагалі не вимагаємо прив’язки і не зберігаємо дані Ваших карток.',
      q2: 'Коли я повинен буду заплатити?',
      a2: 'Оплата списується з вашого внутрішнього балансу в keyCRM за фактом використання, кожного 1-го числа місяця. Оплату Ви можете зробити в будь-який зручний для Вас час. Також можна зробити оплату завчасно, щоб система не заблокувалася при негативному балансі.',
      q3: 'Як я можу заходити в keyCRM?',
      a3: 'Для входу в keyCRM Вам потрібен інтернет і будь-який браузер (Chrome, Opera, Firefox, Microsoft Edge) - на комп’ютері або на телефоні. Також є окремий мобільний додаток.',
      q4: 'Чи будуть мої дані в безпеці?',
      a4: 'Що стосується збереження даних - вони зберігаються в надійному європейському дата-центрі. Також у нас налаштовано регулярне резервне копіювання даних.<br /> Щодо нерозголошення Вашої інформації - згідно <a href="https://ua.keycrm.app/terms-of-use" target="_blank" rel="noopener noreferrer" >Користувацької угоди</a> ми не маємо права розголошувати інформацію наших клієнтів.',
    },
    account: {
      navigation: {
        logout: 'Вийти',
        profile: 'Мій профіль',
        referrals: 'Реферали',
        payments: 'Виплати',
        stats: 'Статистика',
        rules: 'Правила',
      },
      instances: {
        title: 'Доступні CRM',
        name: 'Назва',
        role: 'Роль',
        balance: 'Баланс',
        remove: 'Видалити',
        enter: 'Вхід'
      },
      add_existing: {
        title: 'Додати існуючу CRM',
        subtitle: 'Щоб додати існуючу CRM-систему в цей акаунт необхідно',
        rule_1: 'Виконати вхід в CRM, яку хочете додати в свій акаунт',
        rule_2: 'В цій CRM перейти в Мій профіль → Налаштування',
        rule_3: 'Скопіювати код вашої CRM та вставити його в поле нижче',
        code: 'Код CRM-системи',
        enter_code: 'Введіть код',
        msg_success: 'CRM успішно додана у ваш акаунт',
        msg_exists: 'CRM уже була додана у ваш акаунт раніше',
        msg_error: 'Помилка додавання CRM. Будь ласка, спробуйте ще раз',
      },
      create_new: {
        button_text: 'Створити нову CRM',
        title: 'Нова CRM',
        subtitle: 'Створіть адресу входу в keyCRM для вашої компанії',
      },
      deleting: {
        title: 'CRM, заплановані до видалення',
        confirmation: 'Будуть видалені всі дані по замовленням, заявкам, покупцям та інші дані з CRM <strong>{{domain}}</strong>. Можливість входу буде заблокована. Ви дійсно хочете видалити цю CRM?',
        input_message: 'Для підтвердження введіть: <strong>{{domain}}</strong>',
        queue: 'CRM успішно додано до списку на видалення',
        reverted:  'Видалення успішно скасовано'
      },
      settings: {
        title: 'Дані акаунту',
        title_password: 'Пароль від акаунта',
        full_name: 'Ім\'я та Прізвище',
        oldPassword: 'Поточний пароль',
        password: 'Новий пароль',
        passwordConfirmation: 'Підтвердження паролю',
        passwordConfirmationFailed: 'Паролі не співпадають'
      },
      referrals: {
        title: 'Реферали',
        tab_registrations: 'Реєстрації',
        tab_payments: 'Оплати',
        table_date: 'Дата реєстрації',
        table_user: 'Користувач',
        table_phone: 'Телефон',
        table_count: 'Кіл-сть CRM',
        table_crm_name: 'Назва CRM',
        table_sum: 'Сума оплати',
        table_profit: 'Прибуток',
        table_payment_date: 'Дата оплати',
        table_status: 'Статус',
        table_status_active: 'Активний',
        table_status_pending: 'Очікування',
        activate: 'Активувати реферальну програму',
        activated: 'Реферальна програма успішно активована',
        rules: {
          panel_1: {
            title: 'Що я можу робити в межах реферальної програми?',
            body: 'Щоб заробляти на реферальній програмі, ви можете розповідати про keyCRM своїй аудиторії будь-якими способами, які не суперечать нашим правилам. Які можуть бути варіанти:',
            rule_1: 'Контент-маркетинг: публікація статей (кейсів, оглядів, порівнянь, інструкцій тощо) з використанням платформи у вашому блозі або на інших тематичних ресурсах;',
            rule_2: 'Відеоогляди: повноцінні огляди або згадка про keyCRM у відеоконтенті;',
            rule_3: 'SMM: згадка keyCRM у постах у соціальних мережах;',
            rule_4: 'Email-маркетинг: використання промоматеріалів у розсилках.',
            rule_5: 'Прямі рекомендації: передача промокодів і реферальних посилань вашим клієнтам і знайомим.',
          },
          panel_2: {
            title: 'Що є порушенням умов ревеферального партнерства?',
            body: 'Є кілька важливих правил, порушення яких призведе до ненарахування комісії.',
            rule_1: 'Не можна оплачувати власну підписку в сервісі за власним реферальним посиланням у жодному вигляді чи комбінації.',
            rule_2: 'Заборонено розміщення будь-якої платної реклами з використанням реферального посилання за брендовими запитами keyCRM, keyCRM.app.',
            rule_3: 'Заборонено використовувати спам-методи: розсилки, публікації на форумах і у спільнотах та інші масові способи просування.',
            rule_4: 'Не можна розміщувати реферальне посилання на купонних сайтах, агрегаторах знижок та інших порталах, що спеціалізуються виключно на знижках.',
            rule_5: 'Заборонено надавати неправдиву інформацію про сервіс, а також таку, що шкодить іміджу компанії keyCRM.',
            footer: 'Ознайомтеся з повним переліком правил у партнерській угоді. У разі порушення комісія буде автоматично заблокована, а за повторні порушення ми будемо змушені виключити вас із реферальної програми.'
          }
        }
      },
      payouts: {
        title: 'Історія виплат',
        payout_stat: 'Статистика виплат',
        payout_total: 'Всього нараховано',
        payout_paid: 'Виплачено',
        payout_left: 'Залишок на рахунку',
        payout_request: 'Запит на виведення коштів',
        payout_request_hint: 'Вкажіть реквізити для виплати (карта або рахунок ФОП)',
        table_date: 'Дата створення',
        table_amount: 'Сума',
        table_comment: 'Коментар',
        table_status: 'Статус',
        table_payout_date: 'Дата виплати',
        messages: {
          created: 'Запит на виведення коштів успішно створено. Будь-ласка очікуйте відповіді від менеджера'
        },
      },
      stats: {
        title: 'Статистика реферального посилання',
        button: 'Показати',
        date_from: 'Дата від',
        date_to: 'Дата до',
        table_date: 'Дата',
        table_visits: 'Переходи',
        table_registrations: 'Реєстрації',
      },
    },
    referralBanner: {
      promo: 'Запрошуйте нових користувачів та отримуйте до 50% від їх оплат протягом 12 місяців',
      read_more: 'Дізнатись більше',
      link: 'Ваше реферальне посилання',
    }
  },
  verification: {
    title: 'Введіть код підтвердження з SMS повідомлення',
    failed: 'Код підтвердження введено не правильно',
    countdown_finished: 'Будь ласка, зверніться в чат підтримки',
  },
  validation: {
    mixed: {
      required: '${path} - обов\'язкове поле',
    },
    string: {
      email: '${path} адрес введено не правильно', // don't provide a long messages!!!
      length: '${path} повинен складатись з ${length} цифр',
      min: '${path} повинен бути не менше ${min} символів'
    },
  },
  validation_rules: {
    unique_email: 'E-mail адреса вже використовується',
    unique_phoneNumber: 'Номер телефону вже використовується',
  },
  countries: {
    ukraine: 'Україна',
    // russia: 'Россия',
    // belarus: 'Білорусь',
    usa: 'США',
    poland: 'Польща',
    germany: 'Німеччина',
    lithuania: 'Литва',
    latvia: 'Латвія',
    estonia: 'Естонія',
    kazakhstan: 'Казахстан',
    kyrgyzstan: 'Киргизія',
    uzbekistan: 'Узбекистан',
    portugal: 'Португалія',
    turkey: 'Турція',
    spain: 'Іспанія',
    france: 'Франція',
    britain: 'Великобританія',
    canada: 'Канада',
    australia: 'Австралія',
    moldova: 'Молдова',
    romania: 'Румунія',
    italy: 'Італія',
    azerbaijan: 'Азербайджан',
    georgia: 'Грузія',
    armenia: 'Вірменія',
    slovakia: 'Словаччина',
    belgium: 'Бельгія',
    cyprus: 'Кіпр',
  },
  errors: {
    500: 'Сталася помилка, будь ласка, спробуйте пізніше',
    429: 'Занадто багато запитів, будь ласка, спробуйте пізніше',
    session_expired: 'Час сесії минув, будь ласка, авторизуйтесь знову',
    reserved: 'Цей домен зарезервовано!',
    domain_symbols: 'Домен не може складатися лише з цифр',
    domain_min: 'Мінімальне значення — 4 символи',
    domain_max: 'Максимальне значення — 20 символів',
    network: 'Не вдалося зв’язатися з сервером, перевірте підключення та спробуйте ще раз',
  }
};
